import { Inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router } from "@angular/router";
import { ENVIRONMENT } from "../modules/keycloak.module";
import type { IEnvironment } from "../models/interfaces/environment.interface";
import { MenuStore } from "../stores/menu.store";
import { UserStore } from "../stores/user.store";
import { isLabelsMenuHiddenForUser } from "../utils/carrier-store.util";

const LABELS_MENU_KEY = "labels";

@Injectable({ providedIn: "root" })
export class MenuGuard implements CanActivate {
  constructor(
    private readonly menuStore: MenuStore,
    private readonly router: Router,
    private readonly userStore: UserStore,
    @Inject(ENVIRONMENT) private readonly environment: IEnvironment
  ) {}

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    const menuKey = route.data["menuKey"] as string;
    if (!menuKey) return true;

    if (menuKey === LABELS_MENU_KEY && this.isLabelsHiddenForUser()) {
      void this.router.navigate(["/home"]);
      return false;
    }

    try {
      await this.menuStore.loadMenu();
    } catch {
      void this.router.navigate(["/home"]);
      return false;
    }

    if (this.menuStore.hasItem(menuKey)) return true;
    void this.router.navigate(["/home"]);
    return false;
  }

  private isLabelsHiddenForUser(): boolean {
    const { storeCode } = this.userStore.user();
    return isLabelsMenuHiddenForUser(this.environment.PERMITTED_CORREOS_DE_CHILE_STORE, storeCode);
  }
}
